import React, { useState, useEffect, useContext, useRef } from "react"
import { Button, message, Dropdown, Flex, Input } from "antd"
import { UserContext, useUser } from "../../contexts/UserContext"
import { useTranslation } from "react-i18next"
import { getOrganizations, getResellers, createNewAccount } from "../../api/Cards/users"

const UserFields = ({messageApi} ) => {
    const { t } = useTranslation()
    const { user } = useContext(UserContext)
    const { getToken, isAdmin, getRole } = useUser()
    const [organizations, setOrganizations] = useState([])
    const [selectedOrganization, setSelectedOrganization] = useState(null)
    const [resellers, setResellers] = useState([])
    const [selectedReseller, setSelectedReseller] = useState(null)
    const [invalidFields, setInvalidFields] = useState(false)
    const userData = useRef({})

    useEffect(() => {

        async function getOrgs() {
            const data = await getOrganizations(user.token)

            if (typeof data === "number") {
                return
            }

            setOrganizations(data)
        }
        getOrgs();

    }, [])

    useEffect(() => {

        if (!selectedOrganization)
            return;

        async function getResellerRemote() {
            const data = await getResellers({ Token: user.token, OrganizationId: selectedOrganization.OrganizationId })

            if (typeof data === "number") {
                return
            }
            setResellers(data)
        }

        getResellerRemote()

    }, [selectedOrganization])

    

    function getOrganizationItems() {

        var items = []
        for (var i = 0; i < Object.keys(organizations).length; ++i) {
            items.push(
                { key: i + 1, label:organizations[i + 1].OrganizationName}
            )
        }

        return items
    }

    function getResellerItems() {

        var items = []
        for (var i = 0; i < Object.keys(resellers).length; ++i) {
            items.push(
                { key: i, label: resellers[i].ResellerOrgName + "(" + resellers[i].ResellerName + ")"   }
            )
        }

        return items
    }

    function getSelectedOrganization() {
        if (selectedOrganization === null)
            return t('page.newaccount.ufield.chooseorg')

        return selectedOrganization.OrganizationName
    }

    function getSelectedReseller() {
        if (selectedReseller === null)
            return t('page.newaccount.ufield.chooseres')

        return selectedReseller.ResellerOrgName + " (" + selectedReseller.ResellerName + ")"
    }

    function getStatus(parameter) {
        if (invalidFields && !parameter)
            return "error";

        return ""
    }

    function submitNewAccount() {

        if (
            !userData.current.FirstName ||
            !userData.current.LastName ||
            !userData.current.EMail ||
            !userData.current.Address ||
            !userData.current.Phone ||
            !selectedOrganization ||
            !selectedReseller
        ) {
            setInvalidFields(true);
            return;
        }

        async function createUser() {
            var newUser = {
                Token: user.token,
                NewUserRequest: {
                    ...userData.current,
                    Role: 0,    //User
                    SellerID: selectedReseller.ResellerId,
                    OrgID: selectedOrganization.OrganizationId,
                    OrgName: ""
                }
            }

            var res = await createNewAccount(newUser)
            if (typeof res === "number") {
                console.log("FAILED TO CREATE USER")

                if (res == 409)
                    messageApi.error(t('page.newaccount.ufield.alreadyexists'))

                else
                    messageApi.error(t('page.newaccount.ufield.unknownerror'))

                return;
            }

            messageApi.success(t('page.newaccount.ufield.newacc'))
        }
        createUser();
    }

    return (
        <>
            <div style={{ width: "300px" }} >
                <Input style={{ marginTop: "10px" }} status={getStatus(userData.current.FirstName)} size="large" onChange={(e) => { userData.current.FirstName = e.target.value }} placeholder={t('page.editaccount.fname')} ></Input>
                <Input style={{ marginTop: "10px" }} status={getStatus(userData.current.LastName)} size="large" onChange={(e) => { userData.current.LastName = e.target.value }} placeholder={t('page.editaccount.lname')} ></Input>
                <Input style={{ marginTop: "10px" }} status={getStatus(userData.current.EMail)} size="large" onChange={(e) => { userData.current.EMail = e.target.value }} placeholder={t('page.editaccount.email')} ></Input>
                <Input style={{ marginTop: "10px" }} status={getStatus(userData.current.Address)} size="large" onChange={(e) => { userData.current.Address = e.target.value }} placeholder={t('page.editaccount.adress')} ></Input>
                <Input style={{ marginTop: "10px" }} status={getStatus(userData.current.Phone)} size="large" onChange={(e) => { userData.current.Phone = e.target.value }} placeholder={t('page.editaccount.phone')} ></Input>
                <Dropdown menu={{ items: getOrganizationItems(), onClick: (e) => { setSelectedOrganization(organizations[e.key]) } }}><Button style={getStatus(selectedOrganization) == "error" ? { borderColor: "red", marginTop: "10px", width: "100%" } : { marginTop: "10px", width: "100%" }}>{getSelectedOrganization()}</Button></Dropdown>
                <Dropdown menu={{ items: getResellerItems(), onClick: (e) => { setSelectedReseller(resellers[e.key]) } }}><Button style={ getStatus(selectedReseller) == "error" ? {borderColor:"red", marginTop: "10px", width: "100%"} : {marginTop: "10px", width: "100%" }}>{getSelectedReseller()}</Button></Dropdown>
                <Button style={{ marginTop: "50px", width: "100%" }} type="primary" onClick={submitNewAccount}>{t('page.newaccount.ufield.create')}</Button>

            </div>
        </>
    )
}

export default UserFields